import { FC, useState } from 'react';
import { isEmpty } from 'lodash';
import { useGetPayloadWithProvided } from '~/controllers/wizard';
import { FormItemInjectedProps } from '~/types/FormItemInjectedProps';
import { KsaShareholders } from '~/types/ksa/KsaShareholders';
import { KsaCompanyInformation } from '~/types/ksa/KsaCompanyInformation';
import IndividualTable, {
  getIndividualsData,
} from '~/pages/ksa/application/shareholders/components/individuals/IndividualTable';
import { useCommonErrors } from '~/controllers/validation';
import IndividualEdit from './IndividualEdit';

const IndividualTableForm: FC<Partial<FormItemInjectedProps<KsaShareholders>>> = (props) => {
  const { value } = props as FormItemInjectedProps<KsaShareholders>;
  const shareholdersFormState = { shareholders: value };

  const payload = useGetPayloadWithProvided();

  const [editUid, setUid] = useState('');
  const [, { clearError }] = useCommonErrors();

  const openEdit = (uid: string) => {
    setUid(uid);
    clearError();
  };

  const closeEdit = () => {
    setUid('');
    clearError();
  };

  const individualDataSource = getIndividualsData(shareholdersFormState, openEdit);
  const managers = payload?.managers?.managers;
  const isCheckedAuthorizedSignatory = isEmpty(managers) && individualDataSource.length === 1;
  const isSelectedCompanyLicense =
    isCheckedAuthorizedSignatory &&
    (payload.companyInformation as KsaCompanyInformation)?.thiqahLegalType === '101';

  return (
    <>
      {editUid && (
        <IndividualEdit
          uid={editUid}
          onClose={closeEdit}
          isCheckedAuthorizedSignatory={isCheckedAuthorizedSignatory}
          isSelectedCompanyLicense={isSelectedCompanyLicense}
          {...props}
        />
      )}
      <IndividualTable individuals={individualDataSource} />
    </>
  );
};

export default IndividualTableForm;
